// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"254":"bda0a244bea16750bc76","347":"0f28165e9d8ebeda31e7","540":"0d72ed9c2c9db9ee843c","625":"e99d1a3222e00f3f104d","848":"070a2be300594d464b5a","961":"8cc34e41018deb0a1198"}[chunkId] + ".js";
};